import { useDiagnosticRowActions } from '@ctw/shared/content/diagnostic-reports/helpers/row-actions';
import { PatientDiagnosticReportsOverviewCard } from '@ctw/shared/content/diagnostic-reports/patient-diagnostic-reports-overview-card';
import { usePatientDiagnosticReportsOverviewData } from '@ctw/shared/content/diagnostic-reports/use-patient-diagnostic-reports-overview-data';
import type { SpecificResourceOverviewCardProps } from '@ctw/shared/content/overview/resource-overview-card';
import { withOverviewCardErrorBoundary } from '@ctw/shared/content/overview/with-overview-card-error-boundary';
import { useResourceDrawer } from '@ctw/shared/context/resource-drawer-context';

const TITLE = 'Select Labs';

export const PatientDiagnosticReportsOverview = withOverviewCardErrorBoundary({
  cardTitle: TITLE,
  boundaryName: 'PatientDiagnosticReportsOverview',
  Component: ({ onSeeAllResources }: SpecificResourceOverviewCardProps) => {
    const resourceActions = useDiagnosticRowActions();
    const { openResourceDrawer } = useResourceDrawer({
      enableReadActions: false,
      resourceActions: resourceActions as never,
    });
    const { data, a1cCodes, isLoading, hasNoRecords } = usePatientDiagnosticReportsOverviewData();

    return (
      <PatientDiagnosticReportsOverviewCard
        onRowClick={({ telemetry, record }) => openResourceDrawer({ telemetry, model: record })}
        data={data}
        a1cCodes={a1cCodes}
        isLoading={isLoading}
        emptyState={
          hasNoRecords
            ? "We didn't find any lab records for this patient."
            : 'There are no metabolic or CBC panel and A1C labs for this patient.'
        }
        footerCTA={
          // Keep the CTA visible while loading (chrome renders with a body spinner)
          // and whenever there are records; only hide it once we know there are none.
          isLoading || !hasNoRecords
            ? {
                label: 'All Labs',
                onClick: onSeeAllResources,
              }
            : undefined
        }
      />
    );
  },
});
